"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _immutable = _interopRequireDefault(require("immutable"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _colors = require("HubStyleTokens/colors");

var RequestState = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/RequestState"));

var ecosystemClient = _interopRequireWildcard(require("../../../clients/ecosystemClient"));

var _UIModalPanel = _interopRequireDefault(require("UIComponents/dialog/UIModalPanel"));

var _UIDialogHeader = _interopRequireDefault(require("UIComponents/dialog/UIDialogHeader"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H2"));

var _UIDialogCloseButton = _interopRequireDefault(require("UIComponents/dialog/UIDialogCloseButton"));

var _UIDialogBody = _interopRequireDefault(require("UIComponents/dialog/UIDialogBody"));

var _UIAlert = _interopRequireDefault(require("UIComponents/alert/UIAlert"));

var _renderers = _interopRequireDefault(require("ecosystem-marketplace-core/components/reviews/renderers"));

var _Review = _interopRequireDefault(require("ecosystem-marketplace-core/records/Review"));

var _AppReviewability = _interopRequireDefault(require("../../../records/AppReviewability"));

var textPath = 'appMarketplace.detail.reviews.write.unreviewable.panel'; // Local ActionType constants

var PORTAL_REVIEWS_REQUESTED = 'PORTAL_REVIEWS_REQUESTED';
var PORTAL_REVIEWS_RECEIVED = 'PORTAL_REVIEWS_RECEIVED';
var PORTAL_REVIEWS_FAILED = 'PORTAL_REVIEWS_FAILED';
var initialState = new _immutable.default.Map({
  portalReviews: new _immutable.default.List(),
  portalReviewsFetchStatus: RequestState.UNINITIALIZED
});

var reducer = function reducer(state, action) {
  switch (action.type) {
    case PORTAL_REVIEWS_REQUESTED:
      return state.set('portalReviewsFetchStatus', RequestState.PENDING);

    case PORTAL_REVIEWS_RECEIVED:
      return state.set('portalReviewsFetchStatus', RequestState.SUCCEEDED).set('portalReviews', action.payload);

    case PORTAL_REVIEWS_FAILED:
      return state.set('portalReviewsFetchStatus', RequestState.FAILED);

    default:
      return state;
  }
};

var ExistingPortalReviewsPanel = function ExistingPortalReviewsPanel(_ref) {
  var offeringId = _ref.offeringId,
      onClose = _ref.onClose,
      portalId = _ref.portalId,
      reviewability = _ref.reviewability;

  var _useReducer = (0, _react.useReducer)(reducer, initialState),
      _useReducer2 = (0, _slicedToArray2.default)(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  (0, _react.useEffect)(function () {
    if (state.get('portalReviewsFetchStatus') === RequestState.UNINITIALIZED) {
      ecosystemClient.fetchReviews({
        offeringId: offeringId,
        portalId: portalId
      }).then(function (resp) {
        return dispatch({
          type: PORTAL_REVIEWS_RECEIVED,
          payload: _Review.default.fromArray(resp)
        });
      }).catch(function () {
        return {
          type: PORTAL_REVIEWS_FAILED
        };
      });
    }
  }, [offeringId, portalId, state]);
  var maxPortalReviews = reviewability.maxPortalReviews;
  return _react.default.createElement(_UIModalPanel.default, null, _react.default.createElement(_UIDialogCloseButton.default, {
    onClick: onClose
  }), _react.default.createElement(_UIDialogHeader.default, null, _react.default.createElement(_H.default, null, _react.default.createElement(_FormattedMessage.default, {
    message: textPath + ".header"
  }))), _react.default.createElement(_UIDialogBody.default, null, _react.default.createElement(_UIAlert.default, null, _react.default.createElement(_FormattedMessage.default, {
    message: textPath + ".info",
    options: {
      maxPortalReviews: maxPortalReviews
    }
  })), state.get('portalReviewsFetchStatus') === RequestState.SUCCEEDED && state.get('portalReviews').map(function (review) {
    return _react.default.createElement("div", {
      key: review.id,
      className: "p-bottom-6",
      style: {
        borderBottom: "2px solid " + _colors.GREAT_WHITE
      }
    }, _react.default.createElement(_renderers.default, {
      review: review
    }));
  })));
};

ExistingPortalReviewsPanel.propTypes = {
  offeringId: _propTypes.default.number.isRequired,
  onClose: _propTypes.default.func.isRequired,
  portalId: _propTypes.default.number.isRequired,
  reviewability: _propTypes.default.instanceOf(_AppReviewability.default).isRequired
};
var _default = ExistingPortalReviewsPanel;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/detail/reviews/ExistingPortalReviewsPanel.js
// module id = 875
// module chunks = 209 210 211 212